import React, { FunctionComponent } from "react"
import DatePicker from "react-datepicker"
import { iChangeValueProps } from "../../../definitions/interfaces"
import "react-datepicker/dist/react-datepicker.css"
import { FieldErrors } from "react-hook-form"

interface iProps {
  placeholder?: string
  minDate?: Date
  maxDate?: Date
  showYearDropdown?: boolean
  name: string
  label?: string
  error?: FieldErrors
}

const DateInput: FunctionComponent<iChangeValueProps & iProps> = ({
  onChange,
  value,
  placeholder,
  minDate = new Date("1/1/1900"),
  maxDate = new Date("1/1/2100"),
  showYearDropdown,
  name,
  label,
  error,
}) => {
  const handleChange = (date: Date | [Date, Date] | null) => {
    onChange && onChange(date)
  }

  return (
    <div className="form-group">
      <label htmlFor={name}>
        {label} {error && <span>{error.message}</span>}
      </label>
      <div className="form-control">
        <DatePicker
          onChange={handleChange}
          selected={value ? new Date(value) : null}
          placeholderText={placeholder}
          isClearable={true}
          minDate={minDate}
          maxDate={maxDate}
          showYearDropdown={showYearDropdown}
        />
      </div>
    </div>
  )
}

export default DateInput
